import React from "react";
import { Box, Typography } from "@curves/ui-base";
import clsx from "clsx";
import PrivacyDataToggle from "@icoach/components/PrivacyDataToggle";
import { isEqual } from "@util/utils";

const CustomerNameLabel = ({ sourceData, isRevealed, domProps = {} }) => {
	const { displayName, maskDisplayName, status, cellPhone, maskCellPhone } = sourceData;
	const invalidClass = isEqual(status, 2) ? "invalid" : "";

	return (
		<React.Fragment>
			{/* <Box className="customer-brief-name" data-customer-id={customerID}> */}
			<Box className="customer-brief-name" {...(domProps ?? {})}>
				<PrivacyDataToggle fullData={displayName} maskedData={maskDisplayName} isRevealed={isRevealed} />
				<Typography component="span" className={clsx("state", invalidClass)} />
			</Box>
			<PrivacyDataToggle fullData={cellPhone} maskedData={maskCellPhone} isRevealed={isRevealed} />
		</React.Fragment>
	);
};

export default CustomerNameLabel;
